import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _isNil from "lodash/isNil";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import deleteExcludeGenesFileUpload from 'redux/actions/experimentSettings/deleteExcludeGenesFileUpload';
import { EXPERIMENT_SETTINGS_DISCARD_CHANGED_QC_FILTERS } from '../../../actionTypes/experimentSettings';
var discardChangedQCFilters = function discardChangedQCFilters() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var state, experimentId, excludeGenesIdPrev, excludeGenesIdNext;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            experimentId = state.experimentSettings.info.experimentId;
            excludeGenesIdPrev = state.experimentSettings.originalProcessing.dataIntegration.dimensionalityReduction.excludeGenesId;
            excludeGenesIdNext = state.experimentSettings.processing.dataIntegration.dimensionalityReduction.excludeGenesId;
            if (!(_isNil(excludeGenesIdPrev) && !_isNil(excludeGenesIdNext))) {
              _context.next = 7;
              break;
            }
            _context.next = 7;
            return dispatch(deleteExcludeGenesFileUpload(experimentId));
          case 7:
            dispatch({
              type: EXPERIMENT_SETTINGS_DISCARD_CHANGED_QC_FILTERS,
              payload: {}
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default discardChangedQCFilters;